import { Menu, styled } from '@mui/material';
import { lightPalette, up } from '../../../../theme';
import backgroundImage from '../../../../assets/superAdmin-Dashboard/Group-399.png';

export const classes = {
  root: 'root',
  moreInfoIcon: 'moreInfoIcon',
  externalHeaderTitle: 'externalHeaderTitle',
  externalHeaderAppBar: 'externalHeaderAppBar',
  MainBox: 'MainBox',
  scanHistoryHeader: 'scanHistoryHeader',
  dashboardCardBox: 'dashboardCardBox',
  salesAmountBox: 'salesAmountBox',
  increaseDecreaseRatioBTN: 'increaseDecreaseRatioBTN',
  arrowUpwardIcon: 'arrowUpwardIcon',
  divider: 'divider',
  lastMonthDetailBox: 'lastMonthDetailBox',
  dateRangeContainerBox: 'dateRangeContainerBox',
  dateRangeLabelBox: 'dateRangeLabelBox',
  fromDatePicker: 'fromDatePicker',
  datePickerHeight: 'datePickerHeight',
  datePickerWidth: 'datePickerWidth',
  organizationSelectDropdown: 'organizationSelectDropdown',
  accuracyMonthSelectDropdown: 'accuracyMonthSelectDropdown',
  scanHistoryLineChart: 'scanHistoryLineChart',
  submitButton: 'submitButton',
};

export const StyledMenuProps = {
  PaperProps: {
    sx: {
      maxHeight: 200,
    },
  },
};

export const SelectDurationMenu = styled(Menu)({
  top: '0.5%',
  '& .MuiPaper-root': {
    [up('xs')]: {
      width: '100px',
    },
    [up('sm')]: {
      width: '82px',
    },
    [up('md')]: {
      width: '87px',
    },
    [up('lg')]: {
      width: '95px',
    },
    [up('xl')]: {
      width: '106px',
    },
    [up('xxl')]: {
      width: '109px',
    },
  },
});
export const SelectOrganizationMenu = styled(Menu)({
  top: '0.5%',
  '& .MuiPaper-root': {
    [up('xs')]: {
      width: '100px',
    },
    [up('sm')]: {
      width: '100px',
    },
    [up('md')]: {
      width: '100px',
    },
    [up('lg')]: {
      width: '115px',
    },
    [up('xl')]: {
      width: '131px',
    },
    [up('xxl')]: {
      width: '145px',
    },
  },
});

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.MainBox}`]: {
    overflow: 'auto',
    height: `calc(100vh - ${theme.spacing(6)});`,
    '&::-webkit-scrollbar': {
      width: 0,
    },
    [up('xs')]: {
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.divider}`]: {
    width: '100%',
  },
  [`& .${classes.lastMonthDetailBox}`]: {
    display: 'flex',
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  [`& .${classes.dashboardCardBox}`]: {
    borderRadius: '10px',
    backgroundSize: 'cover',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    ':hover': {
      backgroundImage: `url(${backgroundImage})`,
      color: theme.palette.secondaryWhite.main,
    },
  },
  [`& .${classes.arrowUpwardIcon}`]: {
    marginRight: '0vw',
    marginLeft: '0vw',
    fontSize: '10px',
    height: '14px',
    width: '14px',
    marginBottom: '3px',
    color: lightPalette.salsifyGrass.main,
    ':hover': {
      color: lightPalette.salsifyGrass.main,
    },
  },
  [`& .${classes.increaseDecreaseRatioBTN}`]: {
    backgroundColor: lightPalette.winterMist.main,
    color: lightPalette.salsifyGrass.main,
    textAlign: 'center',
    paddingTop: '3px',
    ':hover': {
      background: lightPalette.winterMist.main,
      color: lightPalette.salsifyGrass.main,
    },
    [up('xs')]: {
      minWidth: '44px',
      height: '27px',
    },
    [up('sm')]: {
      minWidth: '44px',
      height: '21px',
    },
    [up('md')]: {
      minWidth: '44px',
      height: '21px',
    },
    [up('lg')]: {
      minWidth: '44px',
      height: '21px',
    },
    [up('xl')]: {
      minWidth: '50px',
      height: '23px',
    },
    [up('xxl')]: {
      minWidth: '56px',
      height: '26px',
    },
  },
  [`& .${classes.dateRangeLabelBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '1vw',
  },
  [`& .${classes.fromDatePicker}`]: {
    marginBottom: '1.5vh',
  },
  [`& .${classes.datePickerHeight}`]: {
    [up('xs')]: {
      height: '25px',
    },
    [up('sm')]: {
      height: '25px',
    },
    [up('md')]: {
      height: '28px',
    },
    [up('lg')]: {
      height: '25x',
    },
    [up('xl')]: {
      height: '28px',
    },
    [up('xxl')]: {
      height: '30px',
    },
    '& .css-yfc78v-MuiInputBase-input-MuiOutlinedInput-input': {
      [up('xs')]: {
        height: '9px',
      },
      [up('sm')]: {
        height: '10px',
      },
      [up('md')]: {
        height: '11px',
      },
      [up('lg')]: {
        height: '12px',
      },
      [up('xl')]: {
        height: '15px',
      },
      [up('xxl')]: {
        height: '18px',
      },
    },
  },
  [`& .${classes.datePickerWidth}`]: {
    [up('xs')]: {
      width: '15vw',
    },
    [up('sm')]: {
      width: '16vw',
    },
    [up('md')]: {
      width: '15vw',
    },
    [up('lg')]: {
      width: '14vw',
    },
    [up('xl')]: {
      width: '12vw',
    },
    [up('xxl')]: {
      width: '11vw',
    },
  },
  [`& .${classes.dateRangeContainerBox}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    margin: '1vh 2px',
  },
  [`& .${classes.salesAmountBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.heading}`]: {
    [up('lg')]: {
      padding: '36px 0 25px 33px',
    },
    [up('xl')]: {
      padding: '38px 0 27px 35px',
    },
    [up('xxl')]: {
      padding: '49px 0 30px 45px',
    },
  },
  [`& .${classes.scanHistoryHeader}`]: {
    marginBottom: theme.spacing(8),
    marginRight: theme.spacing(3),
  },
  [`& .${classes.moreInfoIcon}`]: {
    position: 'absolute',
    [up('lg')]: {
      top: '0.60rem',
      right: '1.2rem',
    },
    [up('xl')]: {
      top: '1.1rem',
      right: '1.2rem',
    },
    [up('xxl')]: {
      top: '1.313rem',
      right: '1.563rem',
    },
  },
  [`& .${classes.externalHeaderTitle}`]: {
    flexGrow: 1,
    color: theme.palette.darkPurple.main,
    [up('xs')]: {
      display: 'none',
    },
    [up('sm')]: {
      display: 'block',
    },
  },
  [`& .${classes.externalHeaderAppBar}`]: {
    background: theme.palette.japanBlush.main,
    boxShadow: 'none',
    borderRadius: '5px',
    '& .css-10ltm04-MuiToolbar-root': {
      [up('xs')]: {
        padding: '0px 10px 0px 24px',
      },
      [up('sm')]: {
        padding: '0px 10px 0px 24px',
      },
      [up('md')]: {
        padding: '0px 10px 0px 24px',
      },
      [up('lg')]: {
        padding: '8px 10px 8px 24px',
      },
      [up('xl')]: { padding: '10px 10px 10px 24px' },
      [up('xxl')]: {
        padding: '0px 10px 0px 24px',
      },
    },
  },
  [`& .${classes.organizationSelectDropdown}`]: {
    width: '170px',
    '& .css-b2g2ww-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input':
      {
        padding: '5px 5px',
      },
  },
  [`& .${classes.accuracyMonthSelectDropdown}`]: {
    width: '150px',
  },
  [`& .${classes.scanHistoryLineChart}`]: {
    [up('xs')]: {
      minWidth: '530px',
    },
    [up('sm')]: {
      width: '180px',
      height: '350px',
    },
    [up('md')]: {
      minWidth: '590px',
      height: '325px',
      marginTop: '-3vh',
    },
    [up('lg')]: {
      minWidth: '620px',
      height: '325px',
      marginTop: '-3vh',
    },
    [up('xl')]: {
      minWidth: '650px',
      height: '325px',
      marginTop: '-1vh',
    },
    [up('xxl')]: {
      minWidth: '850px',
      height: '350px',
      marginTop: '-2vh',
    },
  },
  [`& .${classes.submitButton}`]: {
    padding: theme.spacing(0.5),
    marginTop: '7px',
    [up('xs')]: {
      fontSize: '6px',
    },
    [up('sm')]: {
      fontSize: '7px',
      marginLeft: theme.spacing(0.5),
    },
    [up('md')]: {
      fontSize: '8px',
      marginLeft: theme.spacing(1),
    },
    [up('lg')]: {
      fontSize: '9px',
    },
    [up('xl')]: {
      fontSize: '10px',
    },
    [up('xxl')]: {
      fontSize: '11px',
    },
  },
}));
